var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30017 6.50017C8.14664 6.50017 7.99295 6.55865 7.87595 6.67595L6.67595 7.87595C6.44135 8.11055 6.44135 8.49039 6.67595 8.72439L11.0517 13.1002L6.67595 17.4759C6.44135 17.7105 6.44135 18.0904 6.67595 18.3244L7.87595 19.5244C8.11055 19.759 8.49039 19.759 8.72439 19.5244L13.1002 15.1486L17.4759 19.5244C17.7099 19.759 18.0904 19.759 18.3244 19.5244L19.5244 18.3244C19.759 18.0898 19.759 17.7099 19.5244 17.4759L15.1486 13.1002L19.5244 8.72439C19.759 8.49039 19.759 8.10995 19.5244 7.87595L18.3244 6.67595C18.0898 6.44135 17.7099 6.44135 17.4759 6.67595L13.1002 11.0517L8.72439 6.67595C8.60709 6.55865 8.45369 6.50017 8.30017 6.50017Z",
    fill: "#00FFB3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    stroke: "#00835B",
    strokeWidth: 2,
    className: "notif-close-progress"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseProgress);
export default __webpack_public_path__ + "static/media/close-progress.c6a83e8b7723904f340e30f5004bb2b7.svg";
export { ForwardRef as ReactComponent };